import { Component, Input, ViewEncapsulation } from '@angular/core';
import { slideLeft } from '../../../shared/animations';

/**
 *	- Sidebar component that allow header and body content to be transcluded in.
 *  - Must be used with sidebar-main-container which is what determines the width of the sidebar
 */
@Component({
  selector: 'smc-sidebar',
  styleUrls: ['./sidebar.component.scss'],
  templateUrl: './sidebar.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [slideLeft],
})
export class SidebarComponent {
  isOverviewOpen = false;
  @Input() hasBackgroundChanged?: boolean;
}
